import gql from 'graphql-tag';
export default gql`
  mutation unarchiveVehicleApplication($applicationId: String!, $userEmail: String!) {
    unarchiveVehicleApplication(applicationId: $applicationId, userEmail: $userEmail)
  }
`;
